<template>
  <div prop="variable" class="sky-copy-scene wsp-line-height-28">
    <div class="wsp-padding-bottom-2 wsp-border-bottom-2 wsp-width-8">
      <strong>行业</strong>
    </div>
    <div class="wsp-display-flex wsp-padding-left-12">
      <div class="wsp-width-49 wsp-display-flex">
        <div class="wsp-display-flex-center"><label>源行业：</label></div>
        <div class="wsp-display-flex-center">{{ variable.sourceIndustryName }}</div>
      </div>
      <div class="wsp-display-flex-center">
        <i class="el-icon-arrow-right" />
      </div>
      <div class="wsp-width-49 wsp-display-flex">
        <div class="wsp-display-flex-center"><label>目标行业：</label></div>
        <div class="wsp-display-flex-center wsp-width-65">
          <el-select
            v-model="variable.targetIndustryId"
            filterable
            style="width: 100% !important;"
            placeholder="请选择目标行业"
            clearable
            @change="isFill"
          >
            <el-option v-for="(item, index) in industryList" :key="index" :label="item.label" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="wsp-padding-bottom-2 wsp-border-bottom-2 wsp-width-8">
      <strong>场景</strong>
    </div>
    <div class="wsp-display-flex wsp-padding-left-12">
      <div class="wsp-width-49 wsp-display-flex">
        <div class="wsp-display-flex-center"><label>源场景：</label></div>
        <div class="wsp-display-flex-center">{{ variable.sourceSceneName }}</div>
      </div>
      <div class="wsp-display-flex-center">
        <i class="el-icon-arrow-right" />
      </div>
      <div class="wsp-width-49 wsp-display-flex">
        <div class="wsp-display-flex-center"><label>目标场景：</label></div>
        <div class="wsp-display-flex-center wsp-width-65">
          <el-input
            popper-class="sky-moudle-branch__autocomplete"
            :class="`${variable.targetSceneName ? '' : 'input-validate-not-null'}`"
            style="width: 100% !important;"
            v-model="variable.targetSceneName"
            @blur="isFill"
          >
          </el-input>
        </div>
      </div>
    </div>
    <div class="wsp-padding-bottom-2 wsp-border-bottom-2 wsp-width-8">
      <strong>产品版本</strong>
    </div>
    <div class="wsp-display-flex wsp-padding-left-12">
      <div class="wsp-width-49 wsp-display-flex">
        <div class="wsp-display-flex-center"><label>源产品版本：</label></div>
        <div class="wsp-display-flex-center wsp-width-50">
          <el-select
            placeholder="请选择源产品版本"
            multiple
            clearable
            v-model="variable.sourceProductList"
            filterable
            style="width: 100% !important;"
            @change="productChange"
          >
            <el-option v-for="(item, index) in productList" :key="index" :label="item.label" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="wsp-display-flex-center">
        <i class="el-icon-arrow-right" />
      </div>
      <div class="wsp-width-49 wsp-display-flex">
        <div class="wsp-display-flex-center"><label>目标产品版本：</label></div>
        <div class="wsp-display-flex-center wsp-width-65">
          <el-input
            placeholder="请选择源产品版本"
            popper-class="sky-moudle-branch__autocomplete"
            style="width: 100% !important;"
            v-model="variable.targetProductNameList"
          >
          </el-input>
        </div>
      </div>
    </div>
    <div style="color: red;">{{ message }}</div>
    <div style="text-align: center;">
      <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px" @click="onConfirm">
        确定
      </el-button>
      <el-button class="sky-branch-pattern__add" style="margin-top:5px" @click="onCancel">
        取消
      </el-button>
    </div>
  </div>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'
import { action } from 'sky-engine/api'

import { INDUSTRY_MNG, BATCH_MAINTENANCE } from '@/api/apiModules'

export default {
  name: 'SkyCopyScene',
  inject: ['rootView'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    scene: {}
  },
  data() {
    return {
      loading: false,
      message: null,
      industryList: [],
      productList: [],
      variable: {
        sourceIndustryId: null,
        sourceIndustryName: null,
        targetIndustryId: null,
        sourceSceneId: null,
        sourceSceneName: null,
        targetSceneName: null,
        sourceProductList: null,
        targetProductList: null,
        sourceProductNameList: null,
        targetProductNameList: null
      }
    }
  },
  created() {
    this.variable.sourceIndustryId = this.scene.industryId
    this.variable.sourceIndustryName = this.scene.industryName
    this.variable.sourceSceneId = this.scene.id
    this.variable.sourceSceneName = this.scene.sceneName
    this.variable.targetSceneName = this.scene.sceneName
  },
  mounted() {
    action(INDUSTRY_MNG, 'findAllIndustry').then(response => {
      this.industryList = response.data.content.itemArr?.map(item => {
        return {
          id: item.id,
          label: item.industryName
        }
      })
    })
    this.productList = this.scene.recommendProductList?.map(item => {
      return {
        id: item.id,
        label: item.productVersion
      }
    })
  },
  watch: {},
  methods: {
    productChange() {
      this.variable.targetProductList = this.variable.sourceProductList
      this.variable.targetProductNameList = this.productList
        .filter(item => {
          return this.variable.sourceProductList.includes(item.id)
        })
        .map(item => item.label)
        .join(', ')
      this.isFill()
    },
    isFill() {
      this.message = ''
      if (this.variable && !this.variable.targetIndustryId) {
        this.message = '请选择目标行业'
        return false
      }
      if (this.variable && !this.variable.targetSceneName) {
        this.message = '请填写目标场景名'
        return false
      }
      if (this.variable && this.variable.sourceProductList?.length == 0) {
        this.message = '请选择源产品版本'
        return false
      }
      return true
    },
    onConfirm() {
      if (!this.isFill()) return
      action(BATCH_MAINTENANCE, 'copyScene', this.variable)
        .then(response => {
          this.$emit('cb')
          this.$store.dispatch('OpenNotification', {
            message: '复制场景成功',
            type: 'success'
          })
        })
        .catch(e => {
          throw e
        })
    },
    onCancel() {
      this.$emit('cb')
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(copy-scene) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 280px !important;
  }
  @include e(mutiple-select) {
    width: 300px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
